import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
export interface modelState {
  cartable:string;
  refKey?: string;
  
}

const initialState: modelState = {
  cartable:'',
  refKey: "",
 
}

export const Slice = createSlice({
  name: 'cartable',
  initialState,
  reducers: {
  
    cartableSet: (state, action) => {

    const {cartable, refKey } = action.payload;
    state.cartable = cartable;

    state.refKey = refKey; 
    
    
  }
  },
})

// Action creators are generated for each case reducer function
export const { cartableSet } = Slice.actions

export default Slice.reducer